import { Component, inject } from '@angular/core'
import { CardComponent } from '@ui/Components/Card/Card.Component'
import { CardContentComponent } from '@ui/Components/Card/CardContent.Component'
import { LoginFormComponent } from '@client/Components/Auth/Login/Form/LoginForm.Component'
import { FormErrorComponent } from '@ui/Components/Form/Error/FormError.Component'

import { TwoFactorChallengeComponent } from '@client/Components/Auth/Login/Form/TwoFactorChallenge.Component'
import { FlatButtonComponent } from '@ui/Components/Form/Button/FlatButton.Component'
import { WebAuthnService } from '@client/Services/WebAuthnService'
import { startAuthentication } from '@simplewebauthn/browser'
import HttpError from '@ui/HttpError'
import { RouterLink } from '@angular/router'

@Component({
	selector: 'login-component',
	templateUrl: './Login.Component.html',
	styleUrls: ['../Auth.css'],
	imports: [
		CardComponent,
		CardContentComponent,
		LoginFormComponent,
		FormErrorComponent,
		TwoFactorChallengeComponent,
		FlatButtonComponent,
		RouterLink,
	],
})
export class LoginComponent {
	public showChallenge = false

	public error: string | null = null

	private readonly redirectEndpoint: string | null = null

	private readonly webAuthnService: WebAuthnService

	constructor() {
		this.redirectEndpoint = '/my-account'

		this.webAuthnService = inject(WebAuthnService)
	}

	public redirect = () => {
		window.location.href = this.redirectEndpoint
	}

	public displayChallengeScreen = () => {
		this.showChallenge = true
	}

	public startWebAuthn = async () => {
		try {
			const optionsJSON = await this.webAuthnService.getOptions()

			// Pass the options to the authenticator and wait for a response
			const assertionResponse = await startAuthentication({ optionsJSON })

			await this.webAuthnService.login(assertionResponse)

			this.redirect()
		} catch (error) {
			if (error instanceof HttpError) {
				this.error = error.message
			} else {
				this.error = 'An error occurred. Please try again.'
			}
		}
	}
}
